<script>
    import { _, time, date } from '../services/i18n'
    import { clientStore } from '../services/session';
    import { getOrders } from "../services/orders";
    import { onMount } from "svelte";

    let clientId = 1;
    let orders = [];

    clientStore.subscribe(async client => {
        clientId = client;
        orders = (await getOrders({ clientId }))
            .sort((a,b) => {
                return b.date - a.date;
            });
    })

    onMount(async () => {
    })
</script>

<main>
    <a id="logo-sim3d" href="/" class=""><img alt="sim3d-logo" src="/icons/default_logo_1.png" class="svelte-1q6abfb"   height="70px;"></a>
    <h1>VR Orders for client { clientId }</h1>
    <section>
        <ul>
            {#each orders as order}
                <li class="order-item">
                    <p id="orderdate">{$date(new Date(order.date))+', '+ $time(new Date(order.date))}</p>
                    <!-- <h2>PEDIDO: <span> {order.reference}</span>: <strong>{order.id}:S3D</strong></h2> -->
                    <h2>PEDIDO: <strong>{order.id}:S3D</strong></h2>
                    {#each order.sceneImages as sceneImage, i}
                        <a href={`vr-viewer.html?scene=/api/v1/gltfscene/${order.id}/${i}`} class="scene-item">
                            <img src={sceneImage} alt="scene" />
                        </a>
                    {/each}
                </li>
            {/each}
        </ul>
    </section>
</main>

<style>

    section {
        display: flex;
        justify-content: center;
        margin-top: 2%;
        overflow-y: auto;
        max-height: 80vh;
        width: 95%;
        margin-left: 2.5%;
    }
    
    li {
        margin-bottom: 25px;
    }

    .scene-item img {
    width: 500px;
    border: 1px solid #36a9e1;
    padding: 3px;
    border-radius: 7px;
    margin: 4px;
    box-shadow: none; 
   }

   #logo-sim3d img {
      margin: 15px;
      margin-top: 15px;
   }

    h1 {
       font-size: 2.5rem;
       color: #1b3258;
       text-align: center;
    }

    h2 {
        font-size: 20px;
        color: #1b3258;
        text-transform: uppercase;
    }
    
    h2 strong {
        color: #36a9e1;

    }

    #orderdate {
        font-size: 16px;
        color: #1b3258;
        margin-bottom: 0;
    }

    ul {
        columns: 2;
    }

    section {
        display: flex;
        justify-content: center;
        margin-top: 2%;
    }


    ::-webkit-scrollbar {
        width: 20px;
    }

    ::-webkit-scrollbar-track {
        background: #1b325873;
        border-radius: 50px;
    }

    ::-webkit-scrollbar-thumb {
        background: #27589cc7;
        border-radius: 50px;

    }

    ::-webkit-scrollbar-thumb:hover {
        background: #36a9e1;
    }

</style>
